import { loadConfiguration, ResourceType, LogLevel, setLogLevel } from "@microsoft/teamsfx";
import { useData } from "./useData";
import { useTeams } from "msteams-react-base-component";

var teamsfxEndpoint = process.env.REACT_APP_TEAMSFX_ENDPOINT;
var startLoginPageUrl = process.env.REACT_APP_START_LOGIN_PAGE_URL;
var clientId = process.env.REACT_APP_CLIENT_ID;

/*var teamsfxEndpoint = "https://surveybotv2.azurewebsites.net/";
var startLoginPageUrl = "auth-start.html";

var clientId = "cd195e2a-ce5b-479d-a5ce-bddcb0173729";
*/
// TODO fix this when the SDK stops hiding global state!
let initialized = false;

export function useTeamsFx() {
  const [result] = useTeams({});
  const { error, loading } = useData(async () => {
    if (!initialized) {
      if (process.env.NODE_ENV === "development") {
        setLogLevel(LogLevel.Verbose);
      } else {
        setLogLevel(LogLevel.Error);
      }
      loadConfiguration({
        authentication: {
          initiateLoginEndpoint: startLoginPageUrl,
          simpleAuthEndpoint: teamsfxEndpoint,
          clientId: clientId,
        },
        resources: [
          // {
          //   type: ResourceType.API,
          //   name: "default",
          //   properties: {
          //     endpoint: functionEndpoint,
          //   },
          // },
        ],
      });
      initialized = true;
    }
  });
  const isInTeams = true;
  return { error, loading, isInTeams, ...result };
}
